import React, { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import Typography from 'src/common/components/Typography';
import TagGroupPills from 'src/listing/components/TagGroupPills';
import type { FullBoatSearchDetail } from 'src/common/types/api/v4/boats/search';
import { TAG_GROUP_IDS } from 'src/common/types/common/TagGroups';
import ContentGroup from 'src/common/components/ContentGroup';
import Divider from 'src/common/components/Divider';
import ListingDetails from '../ListingDetails';

export type BoatDetailsAndTagsProps = {
  make: FullBoatSearchDetail['make'];
  model: FullBoatSearchDetail['model'];
  capacity: FullBoatSearchDetail['capacity'];
  tagGroups: FullBoatSearchDetail['tag_groups'];
};

/** Displays all tag groups except "Experiences", which is shown in `BoatExperiences`  */
const BoatDetailsAndTags: FC<BoatDetailsAndTagsProps> = ({
  make, model, capacity, tagGroups,
}) => {
  const [t] = useTranslation('listing-page');

  const filteredTagGroups = useMemo(() => tagGroups?.filter(
    (tagGroup) => tagGroup.group_id !== TAG_GROUP_IDS.Experiences,
  ), [tagGroups]);

  return (
    <ContentGroup paddingBottom="spacing-07" gapSize="spacing-05">
      <Typography type="h2" size="body-xl" weight="semibold">
        { t('features-and-details--title')}
      </Typography>
      <ListingDetails
        capacity={capacity}
        make={make}
        model={model}
      />
      {filteredTagGroups && filteredTagGroups.map((tagGroup) => (
        <React.Fragment key={tagGroup.group_id}>
          <Divider variant="dashed" withMargin={false} />
          <TagGroupPills tagGroup={tagGroup} />
        </React.Fragment>
      ))}
    </ContentGroup>
  );
};

export default BoatDetailsAndTags;
